import { useState } from "react";

export interface FAQItem { q: string; a: string }

export function FAQ({ items, title = "Perguntas frequentes", defaultOpen = false }: { items: FAQItem[]; title?: string; defaultOpen?: boolean }) {
  return (
    <>
      <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{title}</h2>
      <div className="mt-8 divide-y divide-border rounded-2xl border border-border shadow-[var(--shadow-soft)]">
        {items.map((it, i) => <FAQRow key={i} defaultOpen={defaultOpen} {...it} />)}
      </div>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: items.map((it) => ({
              "@type": "Question",
              name: it.q,
              acceptedAnswer: { "@type": "Answer", text: it.a },
            })),
          }),
        }}
      />
    </>
  );
}

function FAQRow({ q, a, defaultOpen = false }: FAQItem & { defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <details
      open={open}
      onToggle={(e) => setOpen((e.target as HTMLDetailsElement).open)}
      className="group p-5 md:p-6"
    >
      <summary className="flex cursor-pointer list-none items-start justify-between gap-4 text-base font-semibold text-foreground">
        {q}
        <span aria-hidden className="mt-1 text-primary transition-transform group-open:rotate-45">+</span>
      </summary>
      <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{a}</p>
    </details>
  );
}